import footerStyle from "./Footer.module.css";

function Footer() {
    return (
        <img src={'/images/footer.png'} alt={'header'} style={{width: '100vw'}}/>
    )
}

export default Footer;